import React from 'react';
import PropType from 'prop-types';

export const buttonType = {
  primary: 'primary',
  secondary: 'secondary',
  additional: 'additional',
};

export const buttonColor = {
  blue: 'blue',
  lightBlue: 'light-blue',
  green: 'green',
  red: 'red',
  gray: 'gray',
  orange: 'orange',
  planeOrange: 'planeOrange',
  planeRed: 'planeRed',
  darkGreen: 'dark-green',
  darkRed: 'dark-red'
};

const Button = (props) => {
  const buttonClasses = `ect-button ect-button_${props.type} ${props.color} ${props.buttonClassName}
  ${props.disabledWithSpinner ? 'ect-spinner' : ''} ${props.disabled ? 'disabled' : ''}`;

  return (
    <button
      type={props.formButtonType}
      className={buttonClasses}
      disabled={props.disabled || props.disabledWithSpinner}
      onClick={props.onClick}
    >
      <div
        className={props.disabledWithSpinner ? 'ect-spinner__image ect-spinner__image_for-button' : props.iconClassName}
      />
      {!props.disabledWithSpinner && props.label}
    </button>
  );
};

Button.propTypes = {
  formButtonType: PropType.string,
  buttonClassName: PropType.string,
  label: PropType.string,
  type: PropType.string,
  color: PropType.string,
  disabled: PropType.bool,
  disabledWithSpinner: PropType.bool,
  iconClassName: PropType.string,
  onClick: PropType.func
};

Button.defaultProps = {
  formButtonType: 'button',
  buttonClassName: '',
  label: '',
  type: buttonType.primary,
  color: buttonColor.blue,
  disabled: false,
  disabledWithSpinner: false,
  iconClassName: 'icon-not-displayed',
  onClick: () => {}
};

export default Button;



// WEBPACK FOOTER //
// ./src/app/Components/Button.jsx